export default {
  name: 'input_email',
  component_path: 'modules/procedures/blocks/BlockInputEmail',
  static_mandatory: ['email']
}